/** setTimeout wrapper. This exists for mocking purposes only. */
export const setDelayTimeout = (fn: () => void, duration: number) => setTimeout(fn, duration);

/** clearTimeout wrapper. This exists for mocking purposes only. */
export const clearDelayTimeout = (timer: ReturnType<typeof setDelayTimeout>) => clearTimeout(timer);
